<div class="st-input-wrapper">
    <input
        #input
        [type]="effectiveType"
        [min]="min"
        [max]="max"
        [step]="step"
        [disabled]="isDisabled"
        [required]="isRequired"
        [(ngModel)]="val"
        (ngModelChange)="onChange($event)"
        [id]="innerId"
        [class]="aggregatedClass"
        [ngClass]="{ disabled: isDisabled }"
        [name]="name"
        [placeholder]="placeholder"
        [autocomplete]="autocomplete || 'off'"
        [style]="style"
        (blur)="onBlur()"
        [attr.data-st-theme]="theme"
    />

    <button
        *ngIf="type === 'password'"
        type="button"
        class="password-toggle"
        (click)="togglePasswordVisibility()"
        tabindex="-1"
    >
        <i
            class="fa"
            [class.fa-eye-slash]="isPasswordVisible"
            [class.fa-eye]="!isPasswordVisible"
            aria-hidden="true"
        ></i>
    </button>
</div>

<span role="alert" class="text-st-danger" *ngIf="isRequired && !val">
    <small><strong>Ce champ est obligatoire.</strong></small>
</span>
